import { BackendAuthApi } from '@internal/plugin-neo4j-auth-common';

export class BackendAuthNoop implements BackendAuthApi {
  async getToken(): Promise<string> {
    return '';
  }
}
